import React from 'react';
import { Link } from 'react-router-dom';
import './Privacy.css';

function Privacy() {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1 className="page-title">Privacy Policy</h1>
        <p className="last-updated">Last updated: 2026-01-12</p>

        <div className="intro-box">
          <p>
            Apna Soundbox helps Indian merchants receive instant voice notifications for incoming UPI payments. We value your privacy and are committed to protecting your information.
          </p>
        </div>

        <div className="content-section">
          <h2 className="section-title">Information We Collect</h2>
          <ul className="content-list">
            <li>
              <strong>Account Information:</strong> If you sign in (e.g., with Google/Firebase), we may collect your name, email, and profile image.
            </li>
            <li>
              <strong>Device and App Data:</strong> Basic device identifiers, app version, crash logs, and performance metrics to improve reliability.
            </li>
            <li>
              <strong>Payment Notifications:</strong> Apna Soundbox listens to incoming payment notifications on your device to announce "payment received". We do not require your UPI PIN and do not initiate transactions.
            </li>
          </ul>
        </div>

        <div className="content-section">
          <h2 className="section-title">How We Use Information</h2>
          <ul className="content-list">
            <li>Provide instant payment alerts and related app functionality.</li>
            <li>Maintain and improve app performance, reliability, and user experience.</li>
            <li>Prevent abuse, troubleshoot issues, and comply with legal obligations.</li>
          </ul>
        </div>

        <div className="content-section">
          <h2 className="section-title">Data Sharing</h2>
          <p>
            We do not sell your personal information. We may share limited data with service providers (e.g., analytics, crash reporting, authentication) under confidentiality obligations, or when required by law.
          </p>
        </div>

        <div className="content-section">
          <h2 className="section-title">Security</h2>
          <p>
            We use industry-standard measures to protect your data. No method of transmission or storage is 100% secure; we work continuously to improve safeguards.
          </p>
        </div>

        <div className="content-section">
          <h2 className="section-title">Your Choices</h2>
          <ul className="content-list">
            <li>You can manage app permissions in your device settings.</li>
            <li>You may request deletion of your account data by contacting us.</li>
          </ul>
        </div>

        <div className="content-section">
          <h2 className="section-title">Contact</h2>
          <p>
            For privacy questions or requests, contact <a href="mailto:support@apnasoundbox.com">support@apnasoundbox.com</a>.
          </p>
        </div>

        <div className="back-link">
          <Link to="/">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
